import { useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions } from '../Dialog';
import Button from '../Button';
import Checkbox from '../Checkbox';
import Table from '../Table';

export default function SpyRadarDetailsUser({
  openAditionalModuleDialog,
  setOpenAditionalModuleDialog,
  spyRadarLicense,


}) {
  const [selectedIds, setSelectedIds] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [options, setOptions] = useState({ spyradar: null});

useEffect(() => {
  if (!openAditionalModuleDialog) {
    return;
  }

  if (!spyRadarLicense?.selectedBrandly) {
    return;
  }

  const loadSpyRadar = async () => {
    try {
      const res = await fetch(
        "https://hs2api.razamit.pl/spyradaredsnvnr2eiwfwifewkfew?id=" +
        spyRadarLicense.selectedBrandly
      );

      const data = await res.json();

      setOptions({
        spyradar: data || null,
      });
    } catch (err) {
      console.error("Błąd pobierania danych:", err);
    }
  };

  loadSpyRadar();

}, [openAditionalModuleDialog, spyRadarLicense?.selectedBrandly]);



  return (
    <Dialog
      open={openAditionalModuleDialog}
      onClose={() => setOpenAditionalModuleDialog(false)}
      maxWidth="md"
    >
      <DialogTitle>Szczegóły zamówienia SpyRadar</DialogTitle>
      <DialogContent className="overflow-y-auto max-h-[70vh]">
       <div className="space-y-4">
  <div>

    <p className="text-sm text-gray-500">
      Informacje dotyczące aktywnej licencji SpyRadar
    </p>
  </div>

  <div className="grid grid-cols-2 gap-3">
    <div className="rounded-xl bg-gray-50 p-4">
      <p className="text-xs font-medium text-gray-500">
        Liczba źródeł danych
      </p>
      <p className="mt-1 text-sm font-semibold text-gray-900">
        {options.spyradar?.sources || 'N/D'}
      </p>
    </div>

    <div className="rounded-xl bg-gray-50 p-4">
      <p className="text-xs font-medium text-gray-500">
        Cena licencji
      </p>
      <p className="mt-1 text-sm font-semibold text-gray-900">
        {options.spyradar?.price || 'N/D'} / miesiąc netto
      </p>
    </div>

    <div className="rounded-xl bg-gray-50 p-4">
      <p className="text-xs font-medium text-gray-500">
        Minimalna liczba indeksów
      </p>
      <p className="mt-1 text-sm font-semibold text-gray-900">
         {options.spyradar?.index_min || 'N/D'}
      </p>
    </div>

    <div className="rounded-xl bg-gray-50 p-4">
      <p className="text-xs font-medium text-gray-500">
        Maksymalna liczba indeksów
      </p>
      <p className="mt-1 text-sm font-semibold text-gray-900">
        {options.spyradar?.index_max || 'N/D'}
      </p>
    </div>
  </div>

  <div className="flex items-center justify-between rounded-xl border border-green-200 bg-green-50 px-4 py-3">
    <div>
      <p className="text-xs font-medium text-green-700">
        Aktywowano
      </p>
      <p className="mt-1 text-sm font-semibold text-green-900">
        {spyRadarLicense?.brandlyTime}
      </p>
    </div>

    <span className="rounded-full bg-green-100 px-3 py-1 text-xs font-semibold text-green-700">
      Aktywna
    </span>
  </div>
</div>

      </DialogContent>
      <DialogActions>
        <Button
          size="medium"
          variant="outlined"
          onClick={() => setOpenAditionalModuleDialog(false)}
        >
          Zamknij
        </Button>
    
      </DialogActions>
    </Dialog>
  );
}



///zmien dane zaznaczone w tabeli 